import { CloudAuthSignedInState, ControlToken, useCloudAuth } from '@itential/cloud-auth-client';

export function useHasRoles(requiredRoles: string[]): boolean {
    const { state } = useCloudAuth();
    const signedIn = state as CloudAuthSignedInState;
    const controlToken = signedIn?.decodedControlToken as ControlToken;
    const roles = controlToken?.resource_access?.control?.roles;
    if (!Array.isArray(roles)) return false;
    return Object.values(requiredRoles).every((role) => roles.includes(role));
}
